export default {
    current_choice: 'Тековен избор',
    book_now: 'Резервирај сега',
    minimum_age: 'Само над {age} години',
    excess_liability: 'Вишок одговорност',
    security_deposit: 'Депозит за безбедност',
    fuel_policy: 'Политика за гориво',
    like_for_like: 'Исто за исто',
    full_to_full: 'Полн до полн',
    miles_per_rental: '{mileage} бесплатни милји по наем',
    km_per_rental: '{mileage} бесплатни км по наем',
    unlimited_mileage: 'Неограничени милји',
    unlimited_mileage_km: 'Неограничени км',
    non_amendable: 'Не може да се измени',
    non_refundable: 'Не се враќа',
    free_cancellation_until: 'Бесплатно откажување до',
    basic_free_cancellation: 'Бесплатно откажување до 48 часа пред почетокот',
    cancellation_in_line_with: 'Откажување согласно',
    tcs: 'Услови и правила',
    free_extras_on_collection: 'Два бесплатни додатоци при подигнување',
    glass_and_tyres_covered: 'Покриени стакла и гуми',
    number_of_passengers: 'Број на патници',
    number_of_bags: 'Број на торби',
    fuel_type: 'Тип на гориво',
    co2: 'CO2',
    aircon: 'Клима уред',
    transmission: 'Менувач',
    book_type: 'Резервирај {type}',
    debit_card_deposit: 'Дебитна картичка прифатена за депозит',
    fast_track_included: 'Вклучен Fast Track',
    view_all: 'Погледнете сѐ',
};
